export enum GVariantBadgeType {
  ORIGIN = 'ORIGIN',
  VARIANT_B = 'VARIANT_B',
  VARIANT_C = 'VARIANT_C',
  VARIANT_D = 'VARIANT_D',
  VARIANT_E = 'VARIANT_E',
}

export enum GVariantBadgeSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export enum GVariantBadgeTone {
  ACTIVE = 'active',
  SUBDUED = 'subdued',
  INACTIVE = 'inactive',
}
